
export function strip(html) {
    try {
        const tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText;
    } catch (e) {
        return html;
    }
}

export function previewDonorMessage() {
    const maxMessageLength = 1000;
    const form = $('#addAMessageForm')[0];
    if (form.message.value == '' || (form.message.value).indexOf('Post a reply') === 0) {
        alert('Your message appears to be blank.');
    } else if (form.message.value.length > maxMessageLength) {
        alert('Your message appears to be longer than ' + maxMessageLength + ' characters. Please make it shorter.');
    } else {
        $('#messagePreview .comment').html(strip(form.message.value));
        $('#messageEdit').hide();
        $('#messagePreview').show();
        $('#submit').hide();
        $('#cancel').show();
        $('#publish').show();
        $('#publish').focus();
        $('#publish').prop('disabled', false);
        $('#pleaseReview').show();
    }
}

export function cancelDonorMessage() {
    $('#messageEdit').show();
    $('#messagePreview').hide();
    $('#buttonList').show();
    $('#submit').addClass('disabled');
    $('#submit').show();
    $('#cancel').hide();
    $('#publish').hide();
    $('#publish').prop('disabled', true);
    $('#pleaseReview').hide();
}

// Only enable click on preview button if user has entered anything in form
$(function () {
    $(document).on('keyup', '#addAMessageForm #message', function () {
        if ($(this).val() != 0) {
            $('.js-preview-message').removeClass('disabled');
        } else {
            $('.js-preview-message').addClass('disabled');
        }
    });
});
